"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@xstate/react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_2 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const configUtils_1 = require("../../lib/configUtils");
const States_1 = require("../../lib/constants/States");
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const utils_1 = require("../../lib/utils");
const Banners_1 = require("../Banners");
const BookButton_1 = __importDefault(require("../BookButton"));
const styles_1 = require("../BookButton/styles");
const Disclaimer_1 = require("./Disclaimer");
const styles_2 = require("./styles");
/**
 * RegFormFooterContent component.
 *
 * @param {Object} props - The props object.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Array<string>|string} props.disclaimer - The disclaimer content, which can be a string or an array of strings/objects.
 * @param {Function} props.handleTrack - The function to track events.
 * @param {Interpreter} props.service - The xState service object.
 * @param {Object} props.provider - The provider object.
 * @param {Object} props.config - The configuration object.
 *
 * @returns {JSX.Element} The rendered component.
 */
function RegFormFooterContent({ handleSubmit, disclaimer, handleTrack, service, provider, config }) {
    const [state] = (0, react_1.useService)(service);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const phone = (0, configUtils_1.shouldHideSchedulingHelpMessages)(config)
        ? ''
        : (0, utils_1.getMainContactNumber)(provider);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        disclaimer.length ? (react_2.default.createElement(styles_2.DisclaimerContainer, { "data-testId": "disclaimer-container" },
            react_2.default.createElement(Disclaimer_1.Disclaimer, { disclaimer: disclaimer, handleTrack: handleTrack }))) : null,
        !aboveMd && state.matches(`${States_1.patientForm}.${States_1.apptUnavailable}`) && (react_2.default.createElement(styles_1.BannerWrapper, null,
            react_2.default.createElement(Banners_1.AppointmentUnavailableBanner, null))),
        !aboveMd && state.matches(`${States_1.patientForm}.${States_1.error}`) && (react_2.default.createElement(styles_1.BannerWrapper, null,
            react_2.default.createElement(Banners_1.ErrorBookingBanner, { phone: phone }))),
        react_2.default.createElement(BookButton_1.default, { service: service, track: handleTrack, "data-testid": "book_appt_btn", handleSubmit: handleSubmit })));
}
RegFormFooterContent.defaultProps = {
    disclaimer: [],
    handleTrack: () => { }
};
RegFormFooterContent.propTypes = {
    handleSubmit: prop_types_1.default.func,
    service: prop_types_1.default.instanceOf(xstate_1.Interpreter).isRequired,
    provider: prop_types_1.default.object,
    config: prop_types_1.default.object,
    disclaimer: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.arrayOf(prop_types_1.default.string),
        prop_types_1.default.shape({
            sentence: prop_types_1.default.string,
            hasModal: prop_types_1.default.bool,
            modalContent: prop_types_1.default.shape({
                title: prop_types_1.default.string,
                body: prop_types_1.default.arrayOf(prop_types_1.default.string)
            })
        })
    ]),
    handleTrack: prop_types_1.default.func
};
exports.default = RegFormFooterContent;
//# sourceMappingURL=RegFormFooterContent.js.map